var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    { attrs: { name: "bottom", appear: "" } },
    [
      _c(
        "q-page-sticky",
        { key: "v", attrs: { position: "bottom-right", offset: [18, 18] } },
        [
          _c("q-btn", {
            attrs: {
              round: "",
              small: "",
              color: "secondary",
              icon: "arrow_back",
              disabled: _vm.prevDisabled
            },
            on: { click: _vm.goPrev }
          }),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.navLabel))]),
          _vm._v(" "),
          _c("q-btn", {
            attrs: {
              round: "",
              small: "",
              color: "secondary",
              icon: "arrow_forward",
              disabled: _vm.nextDisabled
            },
            on: { click: _vm.goNext }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-702d941c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-702d941c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav-btn.vue
// module id = null
// module chunks = 